var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMigrationActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24.004,
    height: 24,
    rx: 4,
    fill: "#52CA7B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 5H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h4.5v3.085l-1.295-1.29-.705.705L12 14l2.5-2.5-.705-.705-1.295 1.29V9H17a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zM7 6h2v2H7V6zm10 2h-7V6h7v2zM17 15H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1zM7 16h7v2H7v-2zm10 2h-2v-2h2v2z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMigrationActiveIcon);
export default __webpack_public_path__ + "static/media/migrationActiveIcon.643c9c5f97cd2ad17b623950c275fcee.svg";
export { ForwardRef as ReactComponent };